import { Button, Select } from '@mantine/core'

import useGetCampaignList from '../hooks/api/useGetCampaignList'
import useCheckInEventForm from '../hooks/useCheckInEventForm'
import useCheckInEventRelayForm from '../hooks/useCheckInEventRelayForm'

function CheckInEventForm() {
  const { setForm } = useCheckInEventForm()
  const { relay, setRelay } = useCheckInEventRelayForm()
  const { campaigns } = useGetCampaignList()

  const handleChange = (value: string | null) => {
    const targetCampaign = campaigns?.find((c) => c.campaignId.toString() === value)
    setRelay((prev) => ({
      ...prev,
      campaignId: value,
      fromDate: targetCampaign?.startDate.split(' ')[0],
      toDate: targetCampaign?.endDate.split(' ')[0],
    }))
  }

  const applyChange = () => {
    setForm({ ...relay })
  }

  return (
    <div className='flex items-center justify-between w-full h-24 bg-white p-4'>
      <div className='flex gap-4 px-4'>
        <Select
          label='キャンペーン名'
          placeholder='選択してください'
          data={[
            ...(campaigns?.map((c) => ({
              value: c.campaignId.toString(),
              label: c.name,
            })) || []),
          ]}
          value={relay.campaignId}
          onChange={handleChange}
          style={{ width: '450px' }}
          searchable
        />
      </div>
      <div className='flex items-end h-full pb-10'> {/* この行を追加 */}
        <Button className='w-auto' color='#001E61' onClick={applyChange}>
          分析を実行する
        </Button>
      </div> {/* この行を追加 */}
    </div>
  )
}

export default CheckInEventForm
